// extracted by mini-css-extract-plugin
export default {"pageContent":"Page_pageContent__zeK+c"};